import styled from 'styled-components';
const MobileParentWaitingWrapper   = styled.div`
height:100%;
.mt-40{
    margin-top:40px;
}
.parentWaiting {
    .page-header  {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width:80% !important;
        width: var(--page-header-width);
        color: var(--page-header-txtColor);
        background: var(--page-header-bgColor);
        font-family:"open sans", sans-serif;
        z-index:999;
        min-height:90px;
        nav{
        min-height:90px;
        display: -webkit-box;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        flex-direction: column;
        // min-height: 100%;
        margin:0;
        padding:20px;
        }
        .scrollable-content{
            padding-bottom:90px;
        }
        .section-title{
            font-size: 14px;
            color: #ffffff;
            font-weight: 600;
            text-transform: uppercase;
            padding: 0 0 10px;
        }
        .user__not__available{
            width: 235px;
            height: 26px;
            font-family: OpenSans;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: italic;
            line-height: 1.36;
            letter-spacing: normal;
            text-align: left;
            color: #b2b9d6;
        }          

        .user__profile{
            font-family: 'Open Sans',sans-serif;
            margin-left: auto;
            position: relative;
            margin-top:10px;
            .thumb-inner{
                cursor: pointer;
                display: -webkit-box;
                display: -moz-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-align-items: center;
                -webkit-box-align: center;
                -webkit-flex-align: center;
                align-items: center;
                
                h1{
                    font-family: 'Open Sans',sans-serif;
                    font-size: 14px;
                    font-weight:700;
                    color:#fff;
                    margin-left:15px;
                }
                img{
                    width: 40px;
                    height: 40px;
                    border-radius:50%;
                }
                .thumb-initials{
                    background: #B4BBD6;
                    width: 50px;
                    height: 50px;
                    -webkit-text-decoration: none;
                    text-decoration: none;
                    display: block;
                    border-radius: 50%;
                    color: #fff;
                    line-height: 50px;
                    cursor: pointer;
                    text-align: center;
                }
            }
            .status{
                font-size: 10px;
                background: #f6c933;
                width: 130px;
                color:#344177;
                text-align: center;
                border-radius:8px;
                padding: 5px;
                position: absolute;
                font-weight:600;
                left: 53px;
                bottom: -20px;
            }
        }

        h3{
            font:"open sans", sans-serif;
            color:#4eb0de;
            margin:0;
            padding:7px 0 0;
            font-size:14px;
            text-transform:uppercase;
            font-weight:300;
        }
        .logo {
            display: block;
            max-width: 120px;
            margin: 0;
          }
         
            .patient-queue{
                padding:20px;
                >h1{
                font-size:14px;
                color:#ffffff;
                font-weight:600;
                text-transform:uppercase;
                padding:0 0 10px;
                }
                }
            }
    
      }

      .participantList{
        padding:0 20px 20px;
       >ul{
         li{
           padding:0 0 60px;
           .participantList_status{
             display:flex;
             align-items:center;
             .participantList_thumb{
               margin-right:10px;
                >img{
                  min-width:40px;
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                  cursor: pointer;
                }
             }
             .participant_rightpan{
               position:relative;
               width:100%;
              .participantName{
                font-size:14px;
                color:#ffffff;
                font-weight:normal;
                text-transform:capitalize;
                font-weight:700;
                margin: 0;
                padding: 0;
                line-height: normal;
             }
             .user-status{
              position:absolute;
              top: 25px;
              border: solid 1px #f6c933;
              padding: 5px 15px;
              color: #344177;
              font-weight: bold;
              font-size: 0.75rem;
              border-radius: 10px;
              margin-right: 10px;
              text-transform: uppercase;
              letter-spacing: normal;
              line-height: normal;
              &.on-other-call{
                background:#f6c933;
                border-color:#f6c933;
                color:#344177;
              }
              &.available{
                background:#8ec93d;
                border-color:#8ec93d;
                color:#344177;
              }
              &.busy{
                background:#d05353;
                border-color:#d05353;
                color:#344177;
              }
              &.not-available-yet{
                background:#b2b9d6;
                border-color:#b2b9d6;
                color:#344177;
              }
            }

             }
             
           }
         }
       }
    }


    
.page-content{
    //   .call-waiting-msg{
    //       text-align:center;
    //       padding:150px 0 0;
    //       >h1{
    //           color:#b2b9d6;
    //           font-weight:600;
    //           font-size:25px;
    //       }
    //   }
    // }
    .call-waiting-msg{
      text-align: center;
      height: 100%;
      display: flex;
      flex-direction:column;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      left: 0;
        >h1{
            color:#b2b9d6;
            font-weight:600;
            font-size:25px;
            margin-top: 20px;
        }
        .exitvideoRoom_btn{
          font-family: "open sans", sans-serif;
          background:#d05353;
          width: 276px;
          color:#fff;
          height: 36px;
          font-size: 14px;
          line-height: 1;
          font-weight: bold;
          border-radius: 10px;
          text-transform: uppercase;
          border: 0;
          margin-top:30px;
          margin-bottom:auto;
          &.no-error-message {
            margin-top:200px;
          }
        }
    }
  }
}


.close-sidebar{
    font-family:"open sans", sans-serif;
    font-size: 40px;
    top: 20px;
    color: #fff;
    width: 40px;
    height: 40px;
    position: absolute;
    text-align: center;
    right: 20px;
    line-height: 40px;
    font-weight: 100;
  }

.page-header  {
        left: -80%;
        -webkit-animation: slide 0.5s forwards;
        -webkit-animation-delay: 2s;
        animation: slide 0.5s forwards;
        animation-delay: 2s;
       position: fixed;
      top: 0;
      bottom: 0;
      width: 80%;
      color: var(--page-header-txtColor);
      background: var(--page-header-bgColor);
      font-family:"open sans", sans-serif;
      z-index:99999;
      padding:0;
      min-height:90px;
      &.slidein{
        transition: 1s;
        left: 0;
      }
      &.slideout{
        transition: 1s;
        left: -100%;
      }
    }




header.sectionHeader{
    background:#344177;
      display: flex;
      align-items: center;
     
      min-height:92px;
      padding:0 15px;
      .menu-icon{
       cursor: pointer;
      float: right;
      height: 25px;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: all 0.5s ease-in-out 0s;
      -moz-transition: all 0.5s ease-in-out 0s;
      -o-transition: all 0.5s ease-in-out 0s;
      transition: all 0.5s ease-in-out 0s;
      width: 30px;
      z-index: 9;
     
      #notification-sign{
        width: 12px;
        height: 12px;
        border-radius: 12px;
        background: #e83c3c;
        top: -5px;
        right: -5px !important;
        position: absolute;
        z-index: 9;
        float: right;
        left: auto;
      }
        >span{
          background-color: #fff;
      border-radius: 0;
      display: block;
      height: 2.5px;
      left: 0;
      opacity: 1;
      position: absolute;
      -webkit-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      transform: rotate(0deg);
      -webkit-transition: all 0.25s ease-in-out 0s;
      -moz-transition: all 0.25s ease-in-out 0s;
      -o-transition: all 0.25s ease-in-out 0s;
      transition: all 0.25s ease-in-out 0s;
      width: 30px;
          &:nth-child(1){
            top: 0;
          }
          &:nth-child(2){
            top: 10px;
          }
          &:nth-child(3){
            top: 20px;
          }
        }
      }
      .m-logo{
        text-align: center;
        text-align: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        >img{
            display: block;
            max-width: 120px;
            margin: 0;
          }
          >h3{
            color: #4eb0de;
            margin: 0;
            padding: 7px 0 0;
            font-size: 14px;
            text-transform: uppercase;
            font-weight: 300;
          }
      }
      }
    
  }
  .overlay{
    position: fixed;
    background: rgba(0,0,0,0.5);
    content: '';
    z-index: 999;
    height: 100%;
    width: 100%;
    right: 0;
    left:0;
    bottom: 0; 
    &.show{
     display:block;
    }
    &.hide{
      display:none;
    }
}
`;


export default (MobileParentWaitingWrapper);